export default {
  date: 'July 5, 2024',
  title: 'Your Unique Style with Getfloorplan AI',
  description: 'You can order a mix-style design with your own ideas',
  id: 'unique-style',
  jsx: () => (
    <div class='novelty__text'>
      <p>You can order a mix-style design with your own ideas.</p>
      <b>What is Mix-Style?</b>
      <p>Mix-style is a service where you send us your references, and we use our style library to create a demo version of the design for you. We strive to meet your requirements by adapting interior elements to your unique needs.</p>
      <b>Three Situations When Mix-Style is Necessary:</b>
      <p>
        <br></br>
        1. <b>Regional Features </b>
        If your project requires consideration of specific sculptural or regional features that do not conform to the standard styles on our website, mix-style allows you to adapt the design to your unique requirements.
        <br></br>
      </p>
      <p>
        2. <b>Existing Design Style </b>
        If you already have a specific idea about the style of your property and need to align the project with this design style, mix-style will help you achieve the desired result.
        <br></br>
      </p>
      <p>
        3. <b>Unconventional Ideas </b>
        If you have unique and unconventional ideas, mix-style allows you to create a demo version of the design based on the references you provide. This is especially relevant when ordering from three to five projects.
        <br></br>
      </p>
      <p>
        <b>How to Order a Custom Style:</b>
      </p>
      <p>
        1. Describe the project
        <br></br>
        2. Specify the number of layouts
        <br></br>
        3. Mention special requirements (style, view from the window, etc.)
        <br></br>
        4. Send your request
        <a href='mailto:a.kogan@getfloorplan.com'> a.kogan@getfloorplan.com</a>
        <br></br>
      </p>
      <p>Sell property faster with Getfloorplan</p>
    </div>
  ),
  thumb: 'news/24.webp',
};
